import { Box } from '@packages/fenrir/components';
import { Stack } from '@packages/fenrir/components/stack';

import { FlowDataFilters } from '../flow-data-filters/flow-data-filters';
import { FlowDataTable } from '../flow-data-table/flow-data-table';

import { FlowDataDateRange } from './components/flow-data-date-range/flow-data-date-range';
import { FlowDataTabs } from './components/flow-data-tabs/flow-data-tabs';

export const FlowContent = () => {
  return (
    <Stack gap={3}>
      <Box maxWidth={700}>
        <FlowDataDateRange />
      </Box>

      <FlowDataTabs />

      <FlowDataFilters />

      <FlowDataTable />
    </Stack>
  );
};
